export default {
  getAppClientToken: (state) => (state.publicApiProxy || {}).appClientToken,
  getGoogleAuthorizeUrl: (state) => (state.publicApiProxy || {}).googleAuthorizeUrl,
  getGoogleAccessStatus: (state) => (state.publicApiProxy || {}).googleAccessStatus,
  getGoogleUser: (state) => (state.publicApiProxy || {}).googleUser,
  getUserEmailIntegrationType: (state) => (state.publicApiProxy || {}).emailIntegrationType,
};
